import { useCallback } from "react";
import type { Funnel } from "@b2bportal/core-types";
import type { MaintenancePayload } from "../getMaintenanceMessages";
import { Experiments, useExperiment } from "@/modules/experiments/src";

interface MaintenanceMode {
  isMaintenanceEnabled: boolean;
  isFunnelUnderMaintenance: (funnel: Funnel) => boolean;
  maintenancePayload: MaintenancePayload | undefined;
}

export const useMaintenanceMode = (): MaintenanceMode => {
  const { isExperimentVariant, getExperimentJsonPayload } = useExperiment();

  const isMaintenanceEnabled = isExperimentVariant(
    Experiments.MAINTENANCE_PAGE_ENABLED.name,
    "available"
  );

  const maintenancePayload = getExperimentJsonPayload<MaintenancePayload>(
    Experiments.MAINTENANCE_PAGE_ENABLED.name
  );

  const isFunnelUnderMaintenance = useCallback(
    (funnel: Funnel | undefined): boolean => {
      if (!isMaintenanceEnabled) return false;
      if (!maintenancePayload?.funnel) return true;
      return maintenancePayload.funnel.toLowerCase() === funnel?.toLowerCase();
    },
    [isMaintenanceEnabled, maintenancePayload]
  );

  return {
    isMaintenanceEnabled,
    isFunnelUnderMaintenance,
    maintenancePayload,
  };
};
